export class ReferenceType {
  id: number;
  name: string;
  type: string;
  references: Array<any>;
  referencesIds: Array<number | string>;
  options?: Array<any>;

  constructor(data: any) {
    this.id = data.id || null;
    this.name = data.name || '';
    this.type = data.type || null;
    this.options = data.options || [];
    this.references = data.references || [];
    this.referencesIds = data.referencesIds || [];
  }
}
